import React, { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import Logo from '../../images/logo.png';
import i18n from "i18next";

export default function Header(props) {
    const [selectedOption, setSelectedOption] = useState(i18n.resolvedLanguage);

    const changeLanguage = (lng) => {
        console.log("changeLanguage", lng);
        i18n.changeLanguage(lng);
        setSelectedOption(lng);
        if(props.func)
            props.func(lng);
    }

    const languageLabels = {
    va: 'VAL',
    es: 'CAS',
    en: 'ENG',
    fr: 'FRA',
    };
    
    return (
        <>
        <div className="top-header-wrapper">
            <div className="top-header-container w-75">
                <div className="portlet-content">
                    <div className="portlet-content-container">
                        <div className="portlet-body">
                            <Dropdown onSelect={(value) => changeLanguage(value)}
                                className="langSelector">
                                <Dropdown.Toggle variant="light" id="dropdown-language" className="d-flex align-items-center">
                                {languageLabels[selectedOption] || 'CAS'}
                                <FontAwesomeIcon 
                                    icon={faChevronDown} 
                                    className="ms-1" 
                                    aria-hidden="true" 
                                />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                <Dropdown.Item eventKey="va">VAL</Dropdown.Item>
                                <Dropdown.Item eventKey="es">CAS</Dropdown.Item>
                                <Dropdown.Item eventKey="en">ENG</Dropdown.Item>
                                <Dropdown.Item eventKey="fr">FRA</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        {/*<Form.Select onChange={e => changeLanguage(e.target.value)} value={selectedOption}>
                            <option value="va">VAL</option>
                            <option value="es">CAS</option>
                            <option value="en">ENG</option>
                        </Form.Select>*/}
                        {/*<div className="language-selector">
                            
                            <Dropdown className="w-100">
                            <Dropdown.Toggle 
                                id="language-selector-dropdown"
                                className="current-language gva-btn"
                                variant="none"
                                tabIndex={0}
                                aria-label="Trieu un idioma. Llengua Actual: Valencià"
                            >
                                <span aria-hidden="true">Val</span>
                                <FontAwesomeIcon 
                  icon={faChevronDown} 
                  className="ms-1" 
                  aria-hidden="true" 
                />
                            </Dropdown.Toggle>

                            <Dropdown.Menu 
                                className="languages w-100"
                                aria-label="Trieu un idioma"
                            >
                                <Dropdown.Item 
                                as="a"
                                className="language-entry-short-text gva-btn gva-btn-ghost-primary"
                                lang="es-ES" 
                                title="Castellà"
                                aria-label="Canvia Al llenguatge Castellà"
                                onClick={() => changeLanguage('es')}
                                >
                                <span aria-hidden="true">CAS</span>
                                </Dropdown.Item>

                                <Dropdown.Item 
                                as="a"
                                className="gva-btn gva-btn-ghost-primary current"
                                lang="ca-ES" 
                                title="Valencià"
                                aria-current="true"
                                aria-label="Llengua Actual: Valencià"
                                onClick={() => changeLanguage('va')}
                                >
                                <span aria-hidden="true">VAL</span>
                                </Dropdown.Item>

                                <Dropdown.Item 
                                as="a"
                                className="language-entry-short-text gva-btn gva-btn-ghost-primary"
                                lang="en-US" 
                                title="english"
                                aria-label="Canvia Al llenguatge english"
                                onClick={() => changeLanguage('en')}
                                >
                                <span aria-hidden="true">ENG</span>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                            </Dropdown>

                        </div>*/}
                        </div>
                    </div>
                </div>
                {props.token != null && <div className="logout">
                    <span 
                        className="border-end border-white ms-2" 
                        style={{ height: '2em', paddingLeft: '0em'}} 
                        aria-hidden="true"
                        />
                    <FontAwesomeIcon 
                        icon={faPowerOff} 
                        className="ms-1" 
                        aria-hidden="true" 
                        style={{ paddingLeft: '0.5em'}} 
                        onClick={() => props.setToken(null)}
                        />
                </div>}
            </div>
        </div>
        <div className="bottom-header-wrapper">
            <div className="bottom-header-container gva">
                <div id="gva-logo">
                    <a href="https://www.gva.es" target="_blank" rel="noopener noreferrer">
                        <img className="gva-logo" alt="Generalitat Valenciana" src={Logo} />
                    </a>
                </div>
            </div>
        </div>
        </>
    );
}